// Expose React + ReactDOM (and the hooks/helpers the original files use as
// bare identifiers) on globalThis so all the .jsx files keep working without
// per-file imports. Bare identifiers in ESM modules resolve to globalThis
// properties when not otherwise declared.
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

globalThis.React = React;
globalThis.ReactDOM = ReactDOMClient;

// Hooks & helpers commonly used as bare identifiers in the original CDN setup
globalThis.useState = React.useState;
globalThis.useEffect = React.useEffect;
globalThis.useRef = React.useRef;
globalThis.useMemo = React.useMemo;
globalThis.useCallback = React.useCallback;
globalThis.useLayoutEffect = React.useLayoutEffect;
globalThis.useReducer = React.useReducer;
globalThis.useContext = React.useContext;
globalThis.createContext = React.createContext;
globalThis.Fragment = React.Fragment;
globalThis.memo = React.memo;
globalThis.forwardRef = React.forwardRef;
